import { z } from 'zod';

import {
  ReturnLineConditionInput,
  type PatchAdminV1StoresStoreIdReturnsIdBody,
  type Return,
} from '@nucleus-commerce/api-client/admin';

const CONDITIONS = Object.values(ReturnLineConditionInput);

/** Every line needs a condition before the return can be marked inspected (422 on `lines`). */
export const inspectSchema = z.object({
  lines: z.array(
    z.object({
      orderLineId: z.string(),
      condition: z.string().refine((v) => (CONDITIONS as readonly string[]).includes(v), {
        error: 'returns:validation.conditionRequired',
      }),
    }),
  ),
});

export type InspectForm = z.infer<typeof inspectSchema>;

export function emptyInspectForm(ret: Pick<Return, 'lines'>): InspectForm {
  return {
    lines: ret.lines.map((line) => ({
      orderLineId: line.orderLineId,
      condition: line.condition ?? '',
    })),
  };
}

export function toInspectBody(values: InspectForm): PatchAdminV1StoresStoreIdReturnsIdBody {
  return {
    status: 'inspected',
    lines: values.lines.flatMap((line) => {
      const condition = CONDITIONS.find((c) => c === line.condition);
      return condition ? [{ orderLineId: line.orderLineId, condition }] : [];
    }),
  };
}
